import { ArrowLeft } from 'lucide-react';
import { Link, Outlet, useLocation } from 'react-router';
import { AtalhoConversas } from '../atendimento/BarraAtendente';
import { useAvisoNoComputador } from '../lib/push';
import { useSinalDePresenca } from '../lib/presenca';
import { ProvedorInterno } from '../lib/interno-tempo-real';
import { ProvedorTempoReal } from '../lib/tempo-real';
import { PainelSussurro } from '../supervisao/PainelSussurro';

/** A faixa do topo da estação: a marca à esquerda, as Conversas à direita. */
function BarraDoTopo() {
  return (
    <header className="flex shrink-0 items-center justify-between border-b border-neutral-200 px-4 py-1.5 dark:border-neutral-800">
      <span className="text-sm font-semibold tracking-tight">MyMAXX</span>
      <AtalhoConversas />
    </header>
  );
}

/**
 * Moldura de quem só atende: uma faixa fina e nada mais.
 *
 * Era moldura nenhuma (24/09) — a estação ocupava tudo, e o atalho para as Conversas ficava
 * na coluna da esquerda, encostado no seletor de status. O pessoal clicava num querendo o
 * outro o dia inteiro (relato da operação, 08/10). A faixa custa 40 px de altura e põe as
 * duas coisas em cantos opostos da tela, que é o que resolve de verdade.
 */
export function LayoutAtendente() {
  const { pathname } = useLocation();
  const naEstacao = pathname.startsWith('/atendimentos');
  // Vale também fora da estação: quem está em "minha conta" não deixou de estar no turno.
  useSinalDePresenca();
  useAvisoNoComputador();

  if (naEstacao) {
    return (
      <ProvedorTempoReal>
        <ProvedorInterno>
          <div className="flex h-screen min-h-0 flex-col">
            <BarraDoTopo />
            <div className="min-h-0 flex-1">
              <Outlet />
            </div>
          </div>
          <PainelSussurro />
        </ProvedorInterno>
      </ProvedorTempoReal>
    );
  }

  // A conversa interna ocupa a tela inteira e manda na própria rolagem, como a estação;
  // "minha conta" é um formulário curto e continua numa coluna estreita e centralizada.
  // Sem esta distinção o fio de mensagens ficaria sem altura e desabaria dentro da caixa.
  const telaCheia = pathname.startsWith('/interno');

  return (
    <ProvedorTempoReal>
      <ProvedorInterno>
        <div className="flex h-screen flex-col">
          <header className="flex shrink-0 items-center gap-2 border-b border-neutral-200 px-4 py-3 dark:border-neutral-800">
            <Link
              to="/atendimentos"
              className="flex items-center gap-1.5 text-sm text-neutral-600 hover:text-neutral-900 dark:text-neutral-300 dark:hover:text-white"
            >
              <ArrowLeft size={16} /> Voltar ao atendimento
            </Link>
          </header>
          <main
            className={
              telaCheia
                ? 'min-h-0 flex-1 px-4 py-4'
                : 'mx-auto w-full min-h-0 max-w-3xl flex-1 overflow-y-auto px-4 py-6'
            }
          >
            <Outlet />
          </main>
        </div>
        <PainelSussurro />
      </ProvedorInterno>
    </ProvedorTempoReal>
  );
}
